export default {
  auth: {
    checkYourEmail: "Verify your email address",
    emailSent:
      "Click the link in the email we've sent you at {email}, or enter the verification code below.",
    emailWillBeReceived:
      "If an application exists with the provided email address, you will receive an authentication email shortly",
    enterEmail: "Enter your email to check your application status",
    haventReceivedEmail: "Haven't received the email?",
    logIn: "Log In",
    logout: "Logout",
    logOutConfirm: "Are you sure you want to log out of your account?",
    magicLinkResent: "An email has been resent. Please check your inbox.",
    title: "Log In to the @:common.title",
    validEmail: "Please enter a valid email",
    wrongCode: "The confirmation code is invalid",
  },
  application: {
    completeApplication: "Complete Your Application",
    completeDescription: "Click on the link below to complete your application",
    empty: "No application",
    emptyDescription:
      "We don’t have an application under this email address. Please try a different email.",
    resume: "Resume",
    resumeFail: "Resume link could not be generated",
  },
  checkout: {
    addRow: "Add Row",
    checkout: "Checkout",
    nextStep: "Next Step",
    removeRow: "Remove Row",
    noConsentsAvailable: "There are no consents to sign.",
    noContractsAvailable: "There are no contracts to sign.",
    signContract: "Sign Contract",
    contractPartiallyComplete: "This contract is awaiting additional signatures",
    services: {
      chart: {
        title: "Chart",
        description:
          "Securely connect to your IRS account to share your tax information instantly.",
        connect: "Connect",
        connected: "Connected",
        notConnected: "Not Connected",
        error: "Unable to connect to Chart service. Please try again later.",
      },
      vouched: {
        title: "Identity Verification",
        description: "Verify your identity by scanning your ID and taking a selfie.",
        verify: "Verify",
        verified: "Verified",
        notVerified: "Not Verified",
        error: "Unable to start identity verification. Please try again later.",
        verificationFailed: "Verification failed",
      },
    },
  },
  closing: {
    lenderReviewingTitle: "Our lender is reviewing final details",
    lenderReviewingDescription: "Your application has been sent to a lender.",
    uploadDocumentsDescription: "Funder requested additional documents",
    uploadDocumentsTitle: "Upload Required Documents to Proceed",
  },
  common: {
    accept: "Accept",
    accepted: "Accepted",
    address: {
      businessAddress: "Business Address",
      businessAddress2: "Business Address Line 2 (Optional)",
      country: "Country",
      city: "City",
      state: "State",
      zip: "Zip",
    },
    agree: "Agree",
    apiErrorOccurred: "Something went wrong. Please try again later.",
    attach: "Attach",
    cancel: "Cancel",
    contactFundingAdvisor: "Contact Funding Advisor",
    copiedToClipboard: "Copied to Clipboard",
    close: "Close",
    code: "Code",
    confirm: "Confirm",
    continue: "Continue",
    date: "Date",
    decline: "Decline",
    declined: "Declined",
    delete: "Delete",
    edit: "Edit",
    email: "Email",
    errorOccurred: "An error has occurred. Please refresh",
    failedToLoadScript: "Failed to load {name} script",
    funder: "Funder",
    hideDetails: "Hide details",
    itin: "ITIN",
    loading: "Loading",
    noDataAvailable: "No Data Available",
    offer: "Offer",
    offers: "Offers",
    phone: "Phone",
    refresh: "Refresh",
    resend: "Resend",
    resume: "Resume",
    save: "Save",
    saved: "Saved",
    search: "Search",
    selected: "Selected",
    showDetails: "Show details",
    showLess: "Show Less",
    showMore: "Show More",
    signed: "Signed",
    stage: "Stage",
    ssn: "SSN",
    submit: "Submit",
    title: "Borrower Platform",
    upload: "Upload",
  },
  documents: {
    additionalDocumentsRequired: "Additional Documents Required",
    additionalDocumentsRequiredHelp:
      "To continue processing your application, we need a few more documents from you. Please click the Upload Documents button and upload the required files.",
    allUploadedDocuments: "Uploaded",
    documentSuccessfullyUploaded: "Document Successfully Uploaded",
    dyanmicOfferHelp: "The following documents will be required if the selected terms are accepted",
    title: "Documents",
    subtitle: "Please upload all required documents in the box below.",
    requiredDocuments: "Required Documents",
    uploadDocument: "Upload Document",
    uploadDocuments: "Upload Documents",
    uploadedDocuments: "Uploaded Documents",
    uploadHelp: {
      browseDesktop: "browse",
      browseMobile: "Browse",
      mobilePart2: "to upload",
      desktopPart1: "Drag file (doc, pdf, xls, jpg, gif, png, heic) here or",
      desktopPart2: "to upload",
    },
    table: {
      fileName: "File Name",
      documentType: "Document Type",
      fileSize: "File Size",
      ownerPlaceholder: "Select Document Owner",
      filetypePlaceholder: "Select Document Type",
    },
    editModal: {
      title: "Edit Document",
      nameLabel: "File Name",
      typeLabel: "Select File Type",
    },
    previewModal: {
      unsupported1: "File could not be previewed.",
      unsupported2: "Try to download the file.",
    },
    fileSizes: {
      kb: "{size} kb",
      mb: "{size} mb",
    },
    errors: {
      get: "Something went wrong. Please try again later.",
      upload: "File failed to upload. Please try again later.",
      update: "File failed to update. Please try again later.",
      delete: "File failed to delete. Please try again later.",
      preview: "File could not be previewed.",
      missingApplicationId: "Missing application ID.",
      invalidFile:
        "Document is not allowed or has the wrong file type. Please convert it to the proper format.",
    },
  },
  faq: {
    title: "Frequently Asked Questions",
    topics: [
      {
        question: "Will this impact my personal credit?",
        answer:
          "Applying for funding through our marketplace involves a SOFT credit inquiry, which means it won't negatively affect your credit score. We use this information to search the market for the best funding options tailored to your needs. Rest assured, your personal credit remains intact throughout this process.",
      },
      {
        question: "What documents do I need to apply for funding?",
        answer:
          "The documentation required varies depending on the type of funding you're applying for. Generally, you'll need documents such as business bank statements, tax returns, and financial statements. Our team will guide you through the application process and let you know exactly what you need.",
      },
      {
        question: "How quickly will I receive funding?",
        answer:
          "Funding times vary depending on the type of funding you apply for and the completeness of your application. In many cases, you can receive funding in as little as 24 to 48 hours after approval.",
      },
      {
        question: "What amount do I qualify for?",
        answer:
          "The amount of funding you can qualify for depends on various factors such as your business's revenue, credit history, and financial health. Our team will work with you to determine the best funding solution for your specific situation.",
      },
      {
        question: "What is the minimum time in business required to qualify for funding?",
        answer:
          "The time in business requirement varies depending on the type of funding you're seeking and other factors. Generally, we work with businesses who have been operating for over a year. However, there are funding options available for newer businesses as well. Contact us to discuss your specific situation and funding needs.",
      },
      {
        question: "Do you accept personal bank statements?",
        answer:
          "For business funding, we require business bank account statements as they provide a clearer picture of your business's financial health and stability. Unfortunately, lenders cannot accept personal bank statements for this purpose.",
      },
      {
        question: "What products do you have?",
        answer:
          "We offer a variety of funding options tailored to meet your business needs, including lines of credit, term loans, equipment financing, and working capital loans.",
      },
      {
        question: "Can I apply if I have bad credit?",
        answer:
          "Yes, we work with businesses of all credit profiles. While a strong credit history may improve your chances of approval and favorable terms, we consider various factors when evaluating your application.",
      },
      {
        question: "Do you report to the business credit bureaus?",
        answer:
          "Yes, we have lenders who report to business credit bureaus. Timely repayment of your business loan can positively impact your business credit score, which may help you qualify for better financing terms in the future.",
      },
      {
        question: "Do you accept an ITIN?",
        answer:
          "Yes, we do accept an Individual Taxpayer Identification Number (ITIN) as an alternative to a Social Security Number (SSN) for business funding applications.",
      },
      {
        question: "Will applying for funding result in a UCC filing?",
        answer:
          "No, applying for funding does not automatically result in a UCC filing. While some lenders may require a UCC filing as part of their process, we prioritize transparency and only initiate filings when necessary for specific loan products or agreements.",
      },
      {
        question: "What are your rates/terms?",
        answer:
          "Interest rates and terms vary depending on the type of loan and your business's financial profile. Our team will provide you with transparent information about interest rates, fees, and repayment terms tailored to your needs.",
      },
      {
        question: "Is there a prepayment penalty?",
        answer:
          "We have access to flexible financing options with no prepayment penalties. You can pay off your loan early without incurring any additional fees, helping you save on interest costs.",
      },
      {
        question: "How do I qualify for more funds?",
        answer:
          "Qualifying for additional funding depends on various factors, including your business's financial performance, credit history, and repayment capacity. To increase your eligibility for more funds, consider improving your business's revenue, maintaining a positive credit profile, and demonstrating strong financial management practices. Additionally, building a solid relationship with your funding advisor can provide valuable insights and guidance on maximizing your funding opportunities.",
      },
      {
        question: "Will this require a personal guarantee?",
        answer:
          "Yes, the vast majority of business lending, including SBA fundings, requires personal guarantees. This is a common practice in the industry.",
      },
      {
        question: "What percent of business ownership do I need?",
        answer:
          "We can approve as little as a 1% ownership stake for certain products. However, different funding options may require varying levels of ownership. For specific details tailored to your situation, please consult your funding advisor.",
      },
      {
        question: "Do I qualify for monthly payments?",
        answer:
          "Yes, we offer funding products with monthly payment options. Depending on the profile of your business and the specific funding product, other repayment schedules may be required.",
      },
      {
        question: "How does the repayment process work?",
        answer:
          "Repayment processes vary depending on the type of funding you choose. Generally, repayments are made through automatic deductions from your business bank account on a weekly, bi-weekly, or monthly basis.",
      },
      {
        question: "Are there any hidden fees or charges?",
        answer:
          "We believe in transparency and honesty. Our funding solutions come with clear terms and no hidden fees. We'll outline-solid all fees and charges upfront so you can make informed decisions about your financing.",
      },
      {
        question: "Can I use the funds for any purpose?",
        answer:
          "Yes, you can use the funds for a wide range of business purposes, including working capital, inventory purchases, equipment upgrades, marketing initiatives, hiring staff, and more. We provide flexible funding solutions to support your business growth and success.",
      },
      {
        question: "What happens if my application is declined?",
        answer:
          "If your application is declined, don't worry—there are still options available to you. You'll have access to a funding advisor who can help you understand the factors contributing to the decline and guide you on how to address them. Additionally, we offer additional resources such as a personal loan marketplace and a credit building feature to assist you in improving your financial profile for future funding opportunities.",
      },
    ],
  },
  feedback: {
    helpful: "This is helpful",
    letUsKnowWhy: "Let us know why",
    howToImprove: "How can we improve that?",
    notHelpful: "This information is not helpful",
    thankYou: "Thank you for @.lower:feedback.yourFeedback",
    wasThisHelpful: "Was this helpful",
    yourFeedback: "Your feedback",
  },
  floatingButton: {
    askAiInChat: "Ask AI in Chat",
  },
  funded: {
    applicationFundedDescription: "Congratulations! You’ve been funded.",
    applicationFundedPrompt: "You’ve Received Funds!",
  },
  learnWhy: {
    alternatives: {
      description:
        "Regrettably, we’re unable to advance with your business funding application at this time. However, to explore alternative solutions that align with your specific needs, please reach out to your funding advisor.",
      title: "Exploring alternative funding options for your business",
    },
    buttonTitle: "Learn Why",
  },
  navMenu: {
    documents: "Documents",
    businessLoan: "Business Funding",
    faq: "FAQ",
    profile: "Profile",
  },
  offers: {
    acceptOffer: "@:common.accept @:common.offer",
    amountDescription: {
      1: "Offer Amount|Funded Amount",
      2: "Maximum Credit Limit",
      3: "Offer Amount|Funded Amount",
      4: "Offer Amount|Funded Amount",
      5: "Offer Amount|Total Financed Amount",
      9: "Credit Amount|ERC Credit Amount",
    },
    calculateLoanOffer: "Calculate Loan @:common.offer",
    choose: "Choose offer",
    congratulationsDescription:
      "Compare offers and make an informed decision about which lender and terms are best for your business",
    congratulationsTitle: "Congratulations on Receiving Offers!",
    customizable: "Customizable",
    noAdditionalDetails: "There are no additional details to be shown.",
    noOffersHeading: "We're Preparing Offers For You",
    noOffersSubheading: "Your offers will appear here shortly",
    notes: {
      description:
        "This covers estimated terms as prepared by Lendflow on behalf of our lending partner. The lender makes final approval decisions, originates, and services all funding. This offer is not binding and subject to change based on the final evaluation and verification.",
      title: "Your Funding Advisor Note",
    },
    offerDetails: "@:common.offer Details",
    offerEstimate: "@:common.offer Estimate",
    documentCounter: "{count}/{total} documents uploaded",
    documentsUploaded: "Documents uploaded",
    templates: {
      1: "ARLOC is a flexible credit option which allows you to borrow funds against your outstanding invoices. It provides quick access to cash when you need it, helping you manage your cash flow effectively.",
      2: "A Line of Credit is like a financial safety net. It's a pre-approved amount of money you can borrow from a bank or lender whenever you need it. You only pay interest on the amount you use, making it a flexible and cost-effective financing solution.",
      3: "Receivables Purchase is a way to turn your unpaid invoices into immediate cash. You sell your outstanding invoices to a financial institution, and they provide you with the cash upfront, helping you bridge the gap between invoicing and receiving payments.",
      4: "A Term Loan is a straightforward borrowing arrangement where you receive a lump sum of money upfront and repay it over a set period with regular installments. It's a common choice for funding large expenses or business investments with predictable repayment terms.",
      5: "",
    },
    title: "Offers",
    uploadDocuments: "Upload Documents",
  },
  processing: {
    applicationCompletedDescription: "You’ve successfully completed your application.",
    applicationCompletedPrompt: "Your Application is Complete!",
    ourTeamProcessing: "Our team will begin processing your application shortly.",
  },
  profile: {
    business_phone: "Business Phone Number {count}",
    business: "Business",
    calendar_link: "Schedule a Call",
    contact_info: "Contact Information",
    first_name: "First Name",
    general_info: "General Information",
    individual: "Individual",
    last_name: "Last Name",
    modal_title: "Add Additional Phone Number",
    personal_phone: "Personal Phone Number {count}",
    phone_number: "Phone Number",
    save_success: "Profile updated successfully",
    section_title: "Profile Settings",
    type: "Type",
  },
  role: {
    fundingAdvisor: "Funding Advisor",
  },
  chat: {
    greeting: "Hi there! How can I help you?",
    welcomeMessage:
      "Hi there! I'm here 24/7 to assist you with any questions about your application, documents, offers or anything else.",
    errorMessage:
      "We're experiencing technical difficulties at the moment. Please try again later or contact support if the issue persists.",
    placeholder: "Type your message here...",
    send: "Send",
    agentTyping: "Agent is typing...",
    chatWithUs: "Chat with us",
    close: "Close",
    CLOSE: "Close",
    fileId: "File ID:",
    FILE_UPLOAD: {
      INVALID_TYPE: "Invalid file type for {fileName}. Please upload a supported file format.",
      FILE_TOO_LARGE: "File {fileName} is too large. Maximum size is 20MB.",
    },
  },
  footerControls: {
    contactFundingAdvisor: "Contact Funding Advisor",
  },
};
